import { EnhancedDataQualityDashboard } from "@/components/EnhancedDataQualityDashboard";
import { ExpandableValidationTable } from "@/components/ExpandableValidationTable";
import { StatusIcon } from "@/components/StatusIcon";
import { ApiResponse } from "@/types/dataQuality";

interface DataQualityProps {
  apiResponse: ApiResponse;
}

export default function DataQuality({ apiResponse }: DataQualityProps) {
  const hierarchy = apiResponse?.hierarchy || [];

  const enhancedStats = {
    totalTables: apiResponse.summary.total_groups,
    totalFields: apiResponse.summary.valids + apiResponse.summary.errors + apiResponse.summary.warnings,
    timeSeriesData: [
      { date: '2025-09-10', success: apiResponse.summary.valids, warning: apiResponse.summary.warnings, failure: apiResponse.summary.errors },
      { date: '2025-09-09', success: 15, warning: 1, failure: 1 },
      { date: '2025-09-08', success: 14, warning: 2, failure: 1 },
      { date: '2025-09-07', success: 16, warning: 0, failure: 1 },
      { date: '2025-09-06', success: 17, warning: 0, failure: 0 },
    ]
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-foreground">Monitoramento de dados</h1>
        </div>

        {/* Enhanced Dashboard */}
        <EnhancedDataQualityDashboard stats={enhancedStats} apiResponse={apiResponse} />

        {/* Expandable Validation Table */}
        <ExpandableValidationTable hierarchy={hierarchy} />

        {/* Status Legend */}
        <div className="mt-6 flex flex-wrap gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <StatusIcon status="pass" size="sm" />
            <span>Validação passou</span>
          </div>
          <div className="flex items-center gap-2">
            <StatusIcon status="fail" size="sm" />
            <span>Validação falhou</span>
          </div>
          <div className="flex items-center gap-2">
            <StatusIcon status="na" size="sm" />
            <span>Validação não executada</span>
          </div>
        </div>
      </div>
    </div>
  );
}
